import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'classification',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './classification.component.html',
  styleUrl: './classification.component.css'
})
export class ClassificationComponent implements OnInit, OnChanges {

  @Input() roarAssignmentFormData: any;
  @Output() onSaveSection1 = new EventEmitter<any>();

  yesNo = EYesNo;
  classificationForm: FormGroup = new FormGroup([]);

  roarCategories = [
    { label: 'Immediate Concerns and Safety Measures', value: 'immediate_concerns' },
    { label: 'Notifications', value: 'notifications' },
    { label: 'Code of Conduct', value: 'code_of_conduct' },
    { label: 'Intervention and Monitoring Considerations', value: 'intervention_monitoring' },
    { label: 'Parent/Guardian Follow-Up Steps', value: 'follow_up_steps' },
    { label: 'Others', value: 'others' }
  ];

  roarTypes: { [key: string]: string[]; } = {
    'Immediate Concerns and Safety Measures': [
      'Medical Care: Emergency Medical Response/Ambulance',
      'Medical Care: School Nurse',
      'Law Enforcement Involvement: No Action Taken',
      'Law Enforcement Involvement: Ticketed/Charged',
      'Law Enforcement Involvement: Arrested/Detained',
      'Home visit to check for weapons/dangerous materials',
      'Intended victim warned and/or parents/guardians notified',
      'Suicide Risk Assessment/Screening',
      'Mental Health Evaluation: Parent Taking Student to Hospital/ER',
      'Mental Health Evaluation: Ambulance',
      'Mental Health Evaluation: Other',
      'Child Abuse Report to Department of Human Services',
      'Additional Measures to Ensure Safety'
    ],
    'Notifications': [
      'District Administration',
      'Staff and Teachers',
      'Community/Public',
      'Law Enforcement'
    ],
    'Code of Conduct': [
      'Disciplinary Action: Taken',
      'Disciplinary Action: Needed'
    ],
    'Intervention and Monitoring Considerations': [
      'Increased contact/monitoring of subject: Daily',
      'Increased contact/monitoring of subject: Weekly',
      'Increased contact/monitoring of subject: Other',
      'Travel card to hold accountable for whereabouts and on-time arrival to destinations',
      'Backpack, coat, and other belongings checked in/out',
      'Late arrival and/or early dismissal',
      'Increased supervision in specific settings',
      'Modify Daily Schedule',
      'Plan to address harm to self or others created',
      'Plan to address future behavior',
      'Plan to address safety',
      'Plan to address containment',
      'Intervention by support staff',
      'Behavioral assessment',
      'Positive reinforcements for positive behavior',
      'Peer or affective needs support group',
      'Peer support',
      'Intervention by community',
      'Identify precipitating/aggravating circumstances and create intervention to alleviate tension',
      'Drug and/or alcohol intervention',
      'Referral to intervention team',
      'Pro-social discipline',
      'Schedule review of IEP or 504 to review goals and placement options',
      'Virtual/Distance Learning',
      'Alternative School/Setting',
      'Other Actions'
    ],
    'Parent/Guardian Follow-Up Steps': ['Parent/Guardian Follow-Up'],
    'Others': []
  };

  selectedRoarCategory = 'Immediate Concerns and Safety Measures';
  selectedRoarType = 'Medical Care: Emergency Medical Response/Ambulance';

  constructor(
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();

    this.setupFormChangeHandlers();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['roarAssignmentFormData'] && this.roarAssignmentFormData) {
      this.initializeForm();
      if (this.roarAssignmentFormData.roar_category && this.roarTypes[this.roarAssignmentFormData.roar_category]) {
        this.selectedRoarCategory = this.roarAssignmentFormData.roar_category;
        this.selectedRoarType = this.roarAssignmentFormData.roar_type || this.roarTypes[this.selectedRoarCategory][0];
        this.classificationForm.get('roar_type')?.setValue(this.selectedRoarType);
      }
    }
  }

  private initializeForm(): void {
    const group: any = {};

    group['roar_category'] = new FormControl(this.roarAssignmentFormData?.roar_category || this.selectedRoarCategory, Validators.required);
    group['roar_type'] = new FormControl(this.roarAssignmentFormData?.roar_type || this.selectedRoarType, Validators.required);
    group['roar_details'] = new FormControl(this.roarAssignmentFormData?.roar_details || '');
    group['administrative_summary'] = new FormControl(this.roarAssignmentFormData?.administrative_summary || '', Validators.required);

    this.classificationForm = new FormGroup(group);

    this.setupFormChangeHandlers();
  }

  private setupFormChangeHandlers(): void {
    // Subscribe to changes in the roar_category field
    this.classificationForm.get('roar_category')?.valueChanges.subscribe(value => {
      this.selectedRoarCategory = value;
      if (value !== 'Others') {
        this.classificationForm.get('roar_type')?.setValue(this.roarTypes[value][0]);
        this.classificationForm.get('roar_details')?.setValue('');
        this.classificationForm.get('roar_details')?.clearValidators();
      } else {
        this.classificationForm.get('roar_type')?.setValue('');
        this.classificationForm.get('roar_details')?.setValidators([Validators.required]);
      }
    });
    this.classificationForm.get('roar_details')?.updateValueAndValidity();
  }

  saveClassification(): void {
    if (this.classificationForm.valid) {
      this.onSaveSection1.emit(this.classificationForm.value);
    }
  }

}
